import type { ReactNode } from 'react';
import styles from './SideListCard.module.css';
import { BaseCard } from '../BaseCard/BaseCard';

export interface SideListItem {
	id: string;
	label: string;
	sublabel?: string;
	icon?: ReactNode;
	badge?: string;
}

export interface SideListCardProps {
	title: string;
	subtitle?: string;
	items: SideListItem[];
	activeId?: string;
	onSelect?: (id: string) => void;
	actionButton?: { label: string; onClick: () => void; disabled?: boolean };
	filterSlot?: ReactNode;
	footerSlot?: ReactNode;
	stretch?: boolean;
	isLoading?: boolean;
}

export const SideListCard = ({
	title,
	subtitle,
	items,
	activeId,
	onSelect,
	actionButton,
	filterSlot,
	footerSlot,
	stretch = false,
	isLoading = false,
}: SideListCardProps) => {
	return (
		<BaseCard
			title={title}
			subtitle={subtitle}
			actionButton={actionButton}
			footerSlot={footerSlot}
			stretch={stretch}
			children={
				<>
					{filterSlot}
					<div className={styles.list}>
						{isLoading ? (
							Array.from({ length: 5 }).map((_, i) => <div key={i} className={styles.skeletonItem} />)
						) : items.length === 0 ? (
							<div className={styles.empty}>Nenhum item encontrado</div>
						) : (
							items.map((item) => (
								<button
									key={item.id}
									type="button"
									className={`${styles.item} ${activeId === item.id ? styles.itemSelected : ''}`}
									onClick={() => onSelect?.(item.id)}
								>
									{item.icon && <div className={styles.iconSlot}>{item.icon}</div>}
									<div className={styles.itemContent}>
										<div className={styles.itemHeader}>
											<span className={styles.itemLabel}>{item.label}</span>
											{item.badge && <span className={styles.badge}>{item.badge}</span>}
										</div>
										{item.sublabel && <span className={styles.itemSublabel}>{item.sublabel}</span>}
									</div>
								</button>
							))
						)}
					</div>
				</>
			}
		/>
	);
};
